export default "__VITE_ASSET__CVYghgI$__"